// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const FeaturedCollectionsCarousel = require('client-v2/common/components/carousels/featured-collections-carousel')
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const deferDispatch = require('client-v2/common/state/dispatch')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
const collectionActions = require('client-v2/common/models/collection/actions')
// Sibling imports
const { getDenormalizedItems } = require('./selectors')

function mapStateToProps(state) {
  return {
    // Work-around https://app.asana.com/0/102902769366319/928788517144243/f
    isSubscriberCountVisible: false,
    items: getDenormalizedItems(state)
  }
}

function mapDispatchToProps(dispatch) {
  const { dispatchAction } = deferDispatch(dispatch)
  return {
    onCollectionClick: dispatchAction(collectionActions.navigateToCollectionProfile),
    onSubscribeClick: dispatchAction(authModalActions.showSignup)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ImmutableToJS(
    FeaturedCollectionsCarousel
  )
)
